(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-new-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionContainers = document.querySelectorAll('.custom-collections-section');

    sectionContainers.forEach(section => {
      const tabBtns = section.querySelectorAll('.ccs-tab-btn');
      const tabPanes = section.querySelectorAll('.ccs-tab-pane');
      const breadcrumbActiveTab = section.querySelector('.ccs-current-tab');

      // Tab Switching Logic
      tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          // Remove active class from all
          tabBtns.forEach(b => b.classList.remove('active'));
          tabPanes.forEach(p => p.classList.remove('active'));

          // Add active class to clicked tab and corresponding pane
          btn.classList.add('active');
          const targetId = btn.getAttribute('data-target');
          const targetPane = document.getElementById(targetId);
          if (targetPane) {
            targetPane.classList.add('active');
            // Reset scroll position on tab change
            const track = targetPane.querySelector('.ccs-carousel-track');
            if(track && track.parentElement) {
              track.parentElement.scrollLeft = 0;
            }
          }

          // Update Breadcrumb text
          const tabName = btn.getAttribute('data-name');
          if (breadcrumbActiveTab) {
            breadcrumbActiveTab.textContent = tabName;
          }
        });
      });

      // Scroll Progress Bar Logic for each carousel wrapper
      const carouselWrappers = section.querySelectorAll('.ccs-carousel-wrapper');
      
      carouselWrappers.forEach(wrapper => {
        const pane = wrapper.closest('.ccs-tab-pane');
        if(!pane) return;
        
        const progressBar = pane.querySelector('.ccs-progress-bar');
        if(!progressBar) return;

        const updateProgress = () => {
          const scrollLeft = wrapper.scrollLeft;
          const scrollWidth = wrapper.scrollWidth - wrapper.clientWidth;
          
          let progress = 0;
          if (scrollWidth > 0) {
            progress = (scrollLeft / scrollWidth) * 100;
          }
          
          // Calculate a base width for the bar based on visible items vs total
          const visibleRatio = wrapper.clientWidth / wrapper.scrollWidth;
          const minWidthPercent = Math.max(10, visibleRatio * 100); // Minimum 10% width
          
          // Map scroll percentage to movement of the progress bar thumb
          // If thumb is 33% wide, it can move a max of 67% to the right
          const maxTranslate = 100 - minWidthPercent;
          const translatePercent = (progress / 100) * maxTranslate;

          progressBar.style.width = `${minWidthPercent}%`;
          progressBar.style.transform = `translateX(${translatePercent / minWidthPercent * 100}%)`;
        };

        // Listen to scroll events
        wrapper.addEventListener('scroll', updateProgress);
        // Listen to resize events in case device changes orientation
        window.addEventListener('resize', updateProgress);

        // Mouse drag to scroll logic for desktop
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false; // Diferenciar entre clic real y arrastre

        wrapper.addEventListener('mousedown', (e) => {
          isDown = true;
          isDragging = false; // Reiniciamos estado
          startX = e.pageX - wrapper.offsetLeft;
          scrollLeft = wrapper.scrollLeft;
        });

        wrapper.addEventListener('mouseleave', () => {
          isDown = false;
          wrapper.classList.remove('is-dragging');
        });

        wrapper.addEventListener('mouseup', () => {
          isDown = false;
          // Retraso para evitar que se ejecute un clic accidental justo al soltar
          setTimeout(() => {
            wrapper.classList.remove('is-dragging');
            isDragging = false;
          }, 50);
        });

        wrapper.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault(); // Evita selecciones de texto nativas
          const x = e.pageX - wrapper.offsetLeft;
          const walk = (x - startX) * 1.5; 
          
          // Solo activar estado "dragging" si se mueve más de 5 píxeles (ignora micromovimientos del ratón al hacer clic)
          if (Math.abs(walk) > 5) {
            isDragging = true;
            wrapper.classList.add('is-dragging');
          }
          
          wrapper.scrollLeft = scrollLeft - walk;
        });

        // Interceptar eventos click en los enlaces si provienen de un arrastre
        wrapper.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', (e) => {
            if (isDragging) {
              e.preventDefault();
              e.stopPropagation();
            }
          });
        });
        
        // Initialize progress bar
        // Need a slight delay to ensure layout is calculated, especially for hidden tabs
        setTimeout(updateProgress, 100);
        
        // Also update when tab becomes active
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class' && pane.classList.contains('active')) {
              updateProgress();
            }
          });
        });
        observer.observe(pane, { attributes: true });
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sectionContainers = document.querySelectorAll('.tab-cards');

    sectionContainers.forEach((section) => {
      const tabBtns = section.querySelectorAll('.ccs-tab-btn');
      const tabPanes = section.querySelectorAll('.ccs-tab-pane');
      const breadcrumbActiveTab = section.querySelector('.ccs-current-tab');

      // Tab Switching Logic
      tabBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          // Remove active class from all
          tabBtns.forEach((b) => b.classList.remove('active'));
          tabPanes.forEach((p) => p.classList.remove('active'));

          // Add active class to clicked tab and corresponding pane
          btn.classList.add('active');
          const targetId = btn.getAttribute('data-target');
          const targetPane = document.getElementById(targetId);
          if (targetPane) {
            targetPane.classList.add('active');
            // Reset scroll position on tab change
            const track = targetPane.querySelector('.ccs-carousel-track');
            if (track && track.parentElement) {
              track.parentElement.scrollLeft = 0;
            }
          }

          // Update Breadcrumb text
          const tabName = btn.getAttribute('data-name');
          if (breadcrumbActiveTab) {
            breadcrumbActiveTab.textContent = tabName;
          }
        });
      });

      // Scroll Progress Bar Logic for each carousel wrapper
      const carouselWrappers = section.querySelectorAll('.ccs-carousel-wrapper');

      carouselWrappers.forEach((wrapper) => {
        const pane = wrapper.closest('.ccs-tab-pane');
        if (!pane) return;

        const progressBar = pane.querySelector('.ccs-progress-bar');
        if (!progressBar) return;

        const updateProgress = () => {
          const scrollLeft = wrapper.scrollLeft;
          const scrollWidth = wrapper.scrollWidth - wrapper.clientWidth;

          let progress = 0;
          if (scrollWidth > 0) {
            progress = (scrollLeft / scrollWidth) * 100;
          }

          // Calculate a base width for the bar based on visible items vs total
          const visibleRatio = wrapper.clientWidth / wrapper.scrollWidth;
          const minWidthPercent = Math.max(10, visibleRatio * 100); // Minimum 10% width

          // Map scroll percentage to movement of the progress bar thumb
          // If thumb is 33% wide, it can move a max of 67% to the right
          const maxTranslate = 100 - minWidthPercent;
          const translatePercent = (progress / 100) * maxTranslate;

          progressBar.style.width = `${minWidthPercent}%`;
          progressBar.style.transform = `translateX(${(translatePercent / minWidthPercent) * 100}%)`;
        };

        // Listen to scroll events
        wrapper.addEventListener('scroll', updateProgress);
        // Listen to resize events in case device changes orientation
        window.addEventListener('resize', updateProgress);

        // Mouse drag to scroll logic for desktop
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false; // Diferenciar entre clic real y arrastre

        wrapper.addEventListener('mousedown', (e) => {
          isDown = true;
          isDragging = false; // Reiniciamos estado
          startX = e.pageX - wrapper.offsetLeft;
          scrollLeft = wrapper.scrollLeft;
        });

        wrapper.addEventListener('mouseleave', () => {
          isDown = false;
          wrapper.classList.remove('is-dragging');
        });

        wrapper.addEventListener('mouseup', () => {
          isDown = false;
          // Retraso para evitar que se ejecute un clic accidental justo al soltar
          setTimeout(() => {
            wrapper.classList.remove('is-dragging');
            isDragging = false;
          }, 50);
        });

        wrapper.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault(); // Evita selecciones de texto nativas
          const x = e.pageX - wrapper.offsetLeft;
          const walk = (x - startX) * 1.5;

          // Solo activar estado "dragging" si se mueve más de 5 píxeles (ignora micromovimientos del ratón al hacer clic)
          if (Math.abs(walk) > 5) {
            isDragging = true;
            wrapper.classList.add('is-dragging');
          }

          wrapper.scrollLeft = scrollLeft - walk;
        });

        // Interceptar eventos click en los enlaces si provienen de un arrastre
        wrapper.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', (e) => {
            if (isDragging) {
              e.preventDefault();
              e.stopPropagation();
            }
          });
        });

        // Initialize progress bar
        // Need a slight delay to ensure layout is calculated, especially for hidden tabs
        setTimeout(updateProgress, 100);

        // Also update when tab becomes active
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class' && pane.classList.contains('active')) {
              updateProgress();
            }
          });
        });
        observer.observe(pane, { attributes: true });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
